module.exports = __webpack_public_path__ + "img/retail.24b6055f.png";